import { About } from "./about";
import { Contact } from "./contact";
import { Features } from "./features";
import RegistrationForm from "./Form";
import { Gallery } from "./gallery";
import { Header } from "./header";

const Home = (landingPageData) => {
    console.log(landingPageData)
  return (
    <>
      <Header data={landingPageData?.data.Header} />
      <Features data={landingPageData?.data.Features} />
      <About data={landingPageData?.data.About} />

      {/* <Services data={landingPageData.Services} /> */}
      <Gallery data={landingPageData?.data.Gallery} />
      <RegistrationForm />
      <Contact data={landingPageData?.data.Contact}/>
    </>
  );
};

export default Home;
